// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container-edit {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: center;
    align-self: center;
    padding: 20px;
    width: 88%;
}

.form-wrapper {
    /* width: 100%;
    max-width: 800px; */
    border: 1px solid #ccc;
    border-radius: 16px;
    padding: 20px;
    align-self: center;
    border: 1px solid   #D0D0D0;
}

.form-container h2 {
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
    color: #232323;
    font-size: 16px;
}

.form-group input{
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 16px;
    box-sizing: border-box;
}
.form-g textarea{
    width: 100%;
  height: 94px;
  border-radius: 8px;
  border: 1px solid #D0D0D0;
  padding: 12px 10px 12px 10px;
  margin-bottom: 18px;
}


.form-group input[type="number"] {
    --moz-appearance: textfield;
}

.form-group input[type="number"]::-webkit-inner-spin-button,
.form-group input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.password-container {
    position: relative;
}

 .password-toggle-btn {
    position: absolute;
    right: 10px;
    font-size: 14px;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background: none;
    cursor: pointer;
    color: #000000;
} 

.error-message {
    color: red;
    font-size: 14px;
    margin-top: 5px;
} 

::placeholder{
    font-size: 14px;
    font-weight: 400;
    line-height:16.94px;
    color: #808080;
}

h3{
    margin-left: 29px;
}



@media (max-width: 768px) {
    .admin-sidebar {
        width: 200px;
    }

    .form-container {
        padding: 10px;
    }

    .form-group {
        margin-bottom: 10px;
    }

    .password-toggle-btn {
        right: 5px;
    }

    .submit-btn {
        width: 100%;
        padding: 12px;
    }
}



.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); 
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
} 

.submit-btn {
    width: 100%;
    height: 43px;
    padding: 12px 10px 12px 10px;
    background-color: #506CFE;
    border: none;
    border-radius: 8px;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.36px;
    cursor: pointer;
   
}

.submit-btn:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/CRUD/edit/edit.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,UAAU;AACd;;AAEA;IACI;uBACmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,WAAW;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;AACrB;;;AAGA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;CAEC;IACG,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;;;AAIA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;;;AAIA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;;AAEnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":[".form-container-edit {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    justify-content: center;\n    align-self: center;\n    padding: 20px;\n    width: 88%;\n}\n\n.form-wrapper {\n    /* width: 100%;\n    max-width: 800px; */\n    border: 1px solid #ccc;\n    border-radius: 16px;\n    padding: 20px;\n    align-self: center;\n    border: 1px solid   #D0D0D0;\n}\n\n.form-container h2 {\n    margin-bottom: 20px;\n    font-size: 24px;\n    color: #333;\n}\n\n.form-group {\n    margin-bottom: 15px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: 500;\n    color: #232323;\n    font-size: 16px;\n}\n\n.form-group input{\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    font-size: 16px;\n    box-sizing: border-box;\n}\n.form-g textarea{\n    width: 100%;\n  height: 94px;\n  border-radius: 8px;\n  border: 1px solid #D0D0D0;\n  padding: 12px 10px 12px 10px;\n  margin-bottom: 18px;\n}\n\n\n.form-group input[type=\"number\"] {\n    --moz-appearance: textfield;\n}\n\n.form-group input[type=\"number\"]::-webkit-inner-spin-button,\n.form-group input[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.password-container {\n    position: relative;\n}\n\n .password-toggle-btn {\n    position: absolute;\n    right: 10px;\n    font-size: 14px;\n    top: 50%;\n    transform: translateY(-50%);\n    border: none;\n    background: none;\n    cursor: pointer;\n    color: #000000;\n} \n\n.error-message {\n    color: red;\n    font-size: 14px;\n    margin-top: 5px;\n} \n\n::placeholder{\n    font-size: 14px;\n    font-weight: 400;\n    line-height:16.94px;\n    color: #808080;\n}\n\nh3{\n    margin-left: 29px;\n}\n\n\n\n@media (max-width: 768px) {\n    .admin-sidebar {\n        width: 200px;\n    }\n\n    .form-container {\n        padding: 10px;\n    }\n\n    .form-group {\n        margin-bottom: 10px;\n    }\n\n    .password-toggle-btn {\n        right: 5px;\n    }\n\n    .submit-btn {\n        width: 100%;\n        padding: 12px;\n    }\n}\n\n\n\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); \n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 999;\n} \n\n.submit-btn {\n    width: 100%;\n    height: 43px;\n    padding: 12px 10px 12px 10px;\n    background-color: #506CFE;\n    border: none;\n    border-radius: 8px;\n    color: #FFFFFF;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 19.36px;\n    cursor: pointer;\n   \n}\n\n.submit-btn:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
